import { io } from 'socket.io-client';

/**
 * Taichi Socket.io 客戶端
 * 接收 Taichi 後端推送的系統訊息（公告、課程提醒等）
 */

function getTaichiSocketUrl() {
  var legacyApi = process.env.VUE_APP_TAICHI_SOCKETIO_URL ||
    (process.env.VUE_APP_LEGACY_API || '').replace(/\/api$/, '') ||
    '';
  return legacyApi;
}

var socket = null;
var messageCallback = null;
var unreadCountCallback = null;
var shownMessageIds = {};

function hasShownMessage(id) {
  return !!shownMessageIds[id];
}

function markMessageShown(id) {
  if (id) {
    shownMessageIds[id] = true;
  }
}

export function connectTaichiSocket(token) {
  var url = getTaichiSocketUrl();
  if (!token || !url) {
    return null;
  }
  if (socket && socket.connected) {
    return socket;
  }

  // 清理舊的已斷線 socket，避免記憶體洩漏
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  socket = io(url, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 10,
  });

  socket.on('connect', function() {
    console.log('[TaichiSocket] Connected');
    fetchUnreadCount(token);
    fetchLatestUnread(token);
  });

  socket.on('connect_error', function(error) {
    console.error('[TaichiSocket] Connection error:', error && error.message || error);
  });

  socket.on('message:new', function(message) {
    markMessageShown(message.id);
    if (messageCallback) {
      messageCallback(message);
    }
    if (document.hidden && 'Notification' in window && Notification.permission === 'granted') {
      new Notification(message.title || '系統通知', { body: message.content || '' });
    }
  });

  socket.on('reconnect', function() {
    console.log('[TaichiSocket] Reconnected, fetching unread count...');
    fetchUnreadCount(token);
    fetchLatestUnread(token);
  });

  return socket;
}

export function onTaichiMessage(callback) {
  messageCallback = callback;
}

/** 註冊未讀計數更新回調（連線/重連時觸發） */
export function onUnreadCountUpdate(callback) {
  unreadCountCallback = callback;
}

export function disconnectTaichiSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  messageCallback = null;
  unreadCountCallback = null;
}

/** 標記單則訊息為已讀（fire-and-forget） */
export function markMessageAsRead(token, messageId) {
  var url = getTaichiSocketUrl();
  if (!url || !messageId) {
    return Promise.resolve();
  }
  return fetch(url + '/api/messages/' + messageId + '/read', {
    method: 'PATCH',
    headers: { Authorization: 'Bearer ' + token },
  }).catch(function(e) {
    console.error('[TaichiSocket] Mark as read failed:', e);
  });
}

/** 取最新 1 則未讀訊息並觸發通知彈窗 */
function fetchLatestUnread(token) {
  var url = getTaichiSocketUrl();
  if (!url) {
    return;
  }
  fetch(url + '/api/messages?limit=1', {
    headers: { Authorization: 'Bearer ' + token },
  })
    .then(function(res) {
      return res.json();
    })
    .then(function(data) {
      if (data.success && data.messages && data.messages.length > 0 && messageCallback) {
        var msg = data.messages[0];
        if (msg.is_read) {
          return;
        }
        if (msg.id && hasShownMessage(msg.id)) {
          return;
        }
        markMessageShown(msg.id);
        messageCallback(msg);
      }
    })
    .catch(function(e) {
      console.error('[TaichiSocket] Fetch latest unread failed:', e);
    });
}

function fetchUnreadCount(token) {
  var url = getTaichiSocketUrl();
  if (!url) {
    return;
  }
  fetch(url + '/api/messages/stats/unread', {
    headers: { Authorization: 'Bearer ' + token },
  })
    .then(function(res) {
      return res.json();
    })
    .then(function(data) {
      if (data.success && unreadCountCallback) {
        unreadCountCallback(data.unreadCount || 0);
      }
    })
    .catch(function(e) {
      console.error('[TaichiSocket] Fetch unread count failed:', e);
    });
}
